/*
 * This is taken from this gist:
 * https://github.com/hubbado/hubbado_core/commit/b06d387eb0012f5da7342a65de621e4e7c9e98d6
 * but adapted to work with our other selectize changes
 */

import selectize from "@selectize/selectize/dist/js/selectize"
import $ from "jquery"

selectize.define( 'no_results', function( options ) {
  var self = this;

  options = $.extend({
    message: 'No results found.',

    html: function(data) {
      return (
        '<div class="selectize-dropdown ' + data.classNames + '">' +
          '<div class="selectize-dropdown-content">' +
            '<div class="no-results">' + data.message + '</div>' +
          '</div>' +
        '</div>'
      );
    }
  }, options );

  self.displayEmptyResultsMessage = function () {
    this.$empty_results_container.show();
    this.$control.addClass("dropdown-active");
  };

  self.refreshOptions = (function () {
    var original = self.refreshOptions;

    return function () {
      original.apply(self, arguments);
      if (this.hasOptions || !this.lastQuery) {
        this.$empty_results_container.hide()
      } else {
        this.displayEmptyResultsMessage();
      }
    }
  })();

  self.positionDropdown = (function() {
    var original = self.positionDropdown;

    return function() {
      var dropdown = self.$dropdown;

      self.$dropdown = self.$empty_results_container;
      original.apply(self);
      self.$dropdown = dropdown;
      original.apply(self);
    }
  })();

  self.onKeyDown = (function () {
    var original = self.onKeyDown;

    return function ( e ) {
      original.apply( self, arguments );
      if ( e.keyCode === 27 ) {
        this.$empty_results_container.hide();
      }
    }
  })();

  self.onBlur = (function () {
    var original = self.onBlur;

    return function () {
      original.apply( self, arguments );
      this.$empty_results_container.hide();
      this.$control.removeClass("dropdown-active");
    };
  })();

  self.setup = (function() {
    var original = self.setup;
    return function() {
      original.apply(self, arguments);
      self.$empty_results_container = $(options.html($.extend({
        classNames: self.$input.attr('class')
      }, options)));
      self.$empty_results_container.insertBefore(self.$dropdown);
      self.$empty_results_container.hide();
    };
  })();
});
